import * as React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import get from "lodash/get";
import { graphql, useStaticQuery } from "gatsby";
import { RichTextReact } from "../../RichTextReact/RichTextReact";
import { RichText } from "../../../classes/RichText";

const MainWrap = styled.div`
  padding: 3rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  p {
    max-width: 50rem;
  }
`;

const JCCIntakeFormSuccessPage = (props) => {
  const data = useStaticQuery(graphql`
    query {
      contentfulGlobal(title: { eq: "JCC Intake Form Success" }) {
        ...NodeGlobalFields
      }
    }
  `).contentfulGlobal;
  const title = get(data, "title");
  //const copyJson = get(data, "richText1.json");
  return (
    <Container>
      <MainWrap>
        <h2>{title}</h2>
        <RichTextReact content={new RichText(get(data, `richText1`))} />
      </MainWrap>
    </Container>
  );
};

export default JCCIntakeFormSuccessPage;
